var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0106 6.20285C21.7471 5.14883 20.919 4.35832 19.865 4.05717C17.9828 3.56781 12 3.56781 12 3.56781C12 3.56781 6.01721 3.56781 4.13504 4.05717C3.08102 4.32068 2.29051 5.14883 1.98936 6.20285C1.5 8.08502 1.5 11.9999 1.5 11.9999C1.5 11.9999 1.5 15.9148 1.98936 17.797C2.25287 18.851 3.08102 19.6415 4.13504 19.9427C6.01721 20.4321 12 20.4321 12 20.4321C12 20.4321 17.9828 20.4321 19.865 19.9427C20.919 19.6792 21.7095 18.851 22.0106 17.797C22.5 15.9148 22.5 11.9999 22.5 11.9999C22.5 11.9999 22.5 8.08502 22.0106 6.20285ZM9.59082 15.6137V8.38616L15.8396 11.9999L9.59082 15.6137Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.959f81ed83589fa9ebb1c47461906b07.svg";
export { ForwardRef as ReactComponent };